import React, { useState, useMemo } from 'react';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import '../../../form/FileUploader/index.js';
import { FormInput } from '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import { GradientButton } from '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import { ModalComponent } from '../../../ui/modals/Modal/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import { DEFAULT_BOTTOM_MODAL_STYLE_CONFIG, DEFAULT_MODAL_STYLE_CONFIG } from '../../../ui/modals/Modal/config/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';

const RedeemCodeModal = ({
  isOpen,
  onNavBack,
  onClose,
  onCodeChange,
  onSubmit,
  loading,
  afterOpenModal = () => {
  },
  onAfterClose = () => {
  },
  text = {
    title: "Redeem code",
    label: "Enter promo code",
    placeholder: "Enter promo code",
    buttonText: "Redeem"
  }
}) => {
  const { isMobile } = useWindowSize();
  const [code, setCode] = useState("");
  const config = useMemo(
    () => isMobile ? DEFAULT_BOTTOM_MODAL_STYLE_CONFIG() : {
      ...DEFAULT_MODAL_STYLE_CONFIG(),
      content: {
        ...DEFAULT_MODAL_STYLE_CONFIG().content,
        borderRadius: 12
      }
    },
    [isMobile]
  );
  return /* @__PURE__ */ React.createElement(
    ModalComponent.Modal,
    {
      modalIsOpen: isOpen,
      closeModal: () => onClose(),
      hideCloseButton: true,
      onNavBack,
      title: text.title,
      withWrapper: true,
      mobileWrapperV2: true,
      bottom: true,
      afterOpenModal,
      onAfterClose,
      configuration: config
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.box }, /* @__PURE__ */ React.createElement(
      FormInput,
      {
        label: text.label,
        name: "redeem-code",
        value: code,
        onChange: (v) => {
          setCode(v);
          onCodeChange?.(v);
        },
        placeholder: text.placeholder,
        type: "text",
        size: "md"
      }
    ), /* @__PURE__ */ React.createElement(
      GradientButton,
      {
        kind: "fill",
        size: "md-2",
        text: text.buttonText,
        disabled: !code || loading,
        onClick: () => onSubmit(code)
      }
    ))
  );
};
RedeemCodeModal.displayName = "RedeemCodeModal";

export { RedeemCodeModal };
//# sourceMappingURL=index.js.map
